import moment from "moment-timezone";

/**
 * Get total time left in hours, minutes, seconds
 * @param number ms - The milliseconds date
 */
export const timeLeft = (ms) => {
    const date = diff(now(), toDate(ms));

    return {
        h: date.hours() > 9 ? date.hours() : `0${date.hours()}`,
        m: date.minutes() > 9 ? date.minutes() : `0${date.minutes()}`,
        s: date.seconds() > 9 ? date.seconds() : `0${date.seconds()}`,
        d: date.days(),
        isExpired: !(date.days() > 0 || date.hours() > 0 || date.hours() > 0 || date.seconds() > 0)
    }
}

/**
 * To Readable date
 * @param {date} date
 */
export const toHumanized = (date) => moment(date).calendar();

/**
 * Get difference from date a to b
 * @param {date} start
 * @param {date} end
 */
export const diff = (start, end) => moment.duration(end.diff(start));

/**
 * Get current date
 */
export const now = () => moment().tz("UTC");

/**
 * To date
 * @param {date} date
 */
export const toDate = (date) => moment(date).tz("UTC");

/**
 * To event date
 * @param {date} start
 * @param {date} end
 * @param {bool} isSame
 */
export const toEvenDate = (start, end, isSame) => isSame ? end : `${start} - ${end}`;
